
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM10.4287 8.38225C10.1125 8.90934 10 9.56374 10 10H9C9 9.43626 9.13751 8.59066 9.57125 7.86775C10.0207 7.11873 10.7954 6.5 12 6.5C13.0749 6.5 14.084 6.78308 14.7674 7.4017C15.4801 8.04673 15.7672 8.99288 15.4851 10.1213C15.2094 11.224 14.4025 11.6683 13.7948 12.0028C13.7137 12.0475 13.6362 12.0901 13.5639 12.1322C13.2371 12.3224 12.9875 12.5024 12.8096 12.7595C12.6374 13.0084 12.5 13.3781 12.5 14H11.5C11.5 13.2219 11.6751 12.6416 11.9873 12.1905C12.2937 11.7476 12.7004 11.4776 13.0611 11.2678C13.1539 11.2138 13.243 11.1634 13.3281 11.1153L13.3282 11.1152C13.9409 10.7688 14.3503 10.5373 14.5149 9.87873C14.7179 9.06683 14.505 8.51298 14.0964 8.14309C13.6585 7.74678 12.9251 7.5 12 7.5C11.2046 7.5 10.7293 7.88127 10.4287 8.38225ZM11.5 17V15.5H12.5V17H11.5Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiHelpFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
